export default function TermsPage({ hideTopSpace }: { hideTopSpace: boolean }) {
  return (
    <div
      className={`mx-auto flex max-w-[1040px] flex-col py-10 text-product2-content-primary ${hideTopSpace ? 'md:mt-0' : 'md:mt-[100px]'} mb-0 break-words px-[20px] pb-[50px] ${hideTopSpace ? 'mt-0' : 'mt-[50px]'}`}
    >
      <h1
        id="terms-of-use"
        className="text-5xl font-bold text-product2-content-primary"
      >
        Terms of Service
      </h1>
      <div id="fst" className="fex mt-10 flex-col space-y-4">
        <style jsx>
          {`
            h2 {
              margin-top: 40px !important;
            }
          `}
        </style>

        <h2 className="text-3xl font-bold">1. General Provisions</h2>
        <h3 className="text-xl font-semibold">1.1</h3>
        <p>
          Mimo GmbH, Währinger Straße 2-4/48, 1090 Vienna, Austria
          (&ldquo;Mimo,&rdquo; &ldquo;us,&rdquo; or &ldquo;we&rdquo;) provides
          applications for Android and iOS (&ldquo;Apps&rdquo;), websites
          (&ldquo;Websites&rdquo;) and related services such as online
          communities via Discord or live sessions via Zoom (together with the
          Apps and Websites, the &ldquo;Services&rdquo;) that allow you to
          access and use various educational content and training services on
          computer science, data science, programming, software development and
          similar topics as well as tools for software development. Any use of
          the Services is subject to the following terms of service
          (&ldquo;ToS&rdquo;), in each case in the version valid at the time of
          conclusion of any contractual agreement between you and Mimo
          (&ldquo;Contract&rdquo;).
        </p>
        <h3 className="text-xl font-semibold">1.2</h3>
        <p>
          Mimo reserves the right to amend the ToS (&ldquo;Amended ToS&rdquo;)
          at any time and without giving reasons. Amended ToS must be announced
          by us at least 14 days before they come into force by sending the text
          of the Amended ToS to the email address you last provided. If you do
          not object to the changes within these 14 days in writing (e.g. by
          email to support@mimo.org), the changes shall be deemed accepted. If
          Amended ToS affect fees or the scope of Services to existing
          Contracts, these amendments are only permissible with your consent. In
          the event of a timely objection or, as applicable, if no consent is
          given, the Contract shall continue in accordance with the ToS valid at
          the time of conclusion of the contract; however, in such case, your
          Subscription will terminate at the end of the respective Subscription
          Period (no automatic renewal; see section 2.8), without this requiring
          a separate notification by Mimo.
        </p>

        <h2 className="text-3xl font-bold">
          2. Subject and Scope of Services, Subscription
        </h2>
        <h3 className="text-xl font-semibold">2.1</h3>
        <p>
          Mimo is solely responsible for the provision and operation of the
          Services. Mimo assumes no liability that you will successfully
          complete tasks based on our Services or achieve a particular goal or
          learning outcome with our Services.
        </p>
        <h3 className="text-xl font-semibold">2.2</h3>
        <p>
          The scope of the Services may depend on your Subscription type. Mimo
          may publish additional Features. Features are independent of the scope
          of any Services and are provided by Mimo solely at its discretion in
          terms of accessibility, scope and availability. You cannot assert any
          claims for the future from accessing or using the Features. In
          particular, there is no entitlement to permanent access and
          unrestricted use. Mimo may deactivate, change or restrict features at
          any time and without notice.
        </p>
        <h3 className="text-xl font-semibold">2.3</h3>
        <p>
          Mimo offers automatically renewable subscriptions
          (&ldquo;Subscription&rdquo;) at different tiers for different periods
          (&ldquo;Subscription Period&rdquo;). Only Subscription enables you to
          access and use the Services. To enter into the Subscription
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>
            via the Websites, you are required to choose a Subscription Period
            on the Websites, provide your credit card or similar payment
            information, and confirm the Subscription, upon which you will
            receive a receipt via email;
          </li>
          <li>
            via the Apps, you are required to choose a Subscription Period
            within the Apps and confirm your Subscription, upon which you will
            receive a receipt via email; this Subscription uses the in-app
            purchase functionality of third-party App Stores; the App Store on
            iOS and Google Play on Android (&ldquo;App Stores&rdquo;).
          </li>
        </ol>
        <h3 className="text-xl font-semibold">2.4</h3>
        <p>
          To subscribe, access and use the Services via the Website, the
          prerequisite is registration by creating an account. Registration is
          not obligatory when using the apps. However, you may use your email
          address along with a self-determined password or a single sign-on
          application provided by third parties such as Apple, Facebook, or
          Google (if provided by Mimo) to create an account. In this connection
          you
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>
            agree to provide accurate, complete, and current information about
            you as requested by Mimo;
          </li>
          <li>
            are required to maintain the confidentiality of your password and
            other information related to the security of your account.
          </li>
        </ol>
        <h3 className="text-xl font-semibold">2.5</h3>
        <p>
          To create an account, you are required to be at least eighteen years
          of age. If you are at least fourteen years of age, you are allowed to
          create an account with the consent of your legal guardians. Mimo has
          the right to make its services subject to appropriate proof of
          identity and/or consent of your legal guardians.
        </p>
        <h3 className="text-xl font-semibold">2.6</h3>
        <p>
          The conclusion of a Subscription is subject to payment (&ldquo;Payment
          Obligation&rdquo;), due at the beginning of the Subscription.
          Concerning Subscriptions entered into
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>
            on the Websites, payment will be made using the credit card or
            similar payment information provided by you upon the conclusion of
            the Subscription;
          </li>
          <li>
            within the Apps, payment will be made through the in-app purchase
            functionality provided by the App Stores.
          </li>
        </ol>
        <h3 className="text-xl font-semibold">2.7</h3>
        <p>
          A Subscription to our Services will automatically renew unless
          terminated at least twenty-four hours before the expiration of the
          Subscription Period. Mimo will inform you about the upcoming renewal
          at least 15 days in advance via email to the email address you last
          provided. Upon renewal, the Subscription Period will be extended by an
          additional equivalent Subscription Period. Your Payment Obligation
          will renew together with your Subscription.
        </p>
        <h3 className="text-xl font-semibold">2.8</h3>
        <p>
          Mimo may occasionally offer you access and use of an extended scope of
          the Services for trial purposes (&ldquo;Trial&rdquo;) for different
          periods (&ldquo;Trial Periods&rdquo;). Trials are Subscriptions free
          of charge that may, at our sole discretion, be determined, suspended,
          or discontinued at any time. To start the Trial, you may be required
          to provide your credit card information and confirm the Trial. Your
          Trial may convert into a subscription after the Trial Period. This and
          the Subscription Period will be part of the information provided in
          the trial offer. To prevent a Trial from converting into a
          Subscription with payment obligation, you may terminate the Trial
          within the Trial Period on the Websites or within the App Stores,
          depending on how you entered into the Trial.
        </p>

        <h2 className="text-3xl font-bold">3. Reservation of Rights</h2>
        <h3 className="text-xl font-semibold">3.1</h3>
        <p>
          Any rights regarding the Services or documents, in particular,
          learning- or project documents, scripts, databases, or other learning
          material and content (including recordings) available through the
          Services, including audio, designs, graphics, images, information,
          software, text and other files as well as their arrangement and
          selection (together &ldquo;IP&rdquo;) provided to you are protected
          and belong to Mimo or our licensors. Subject to this ToS, Mimo grants
          you a non-exclusive and non-transferable license regarding the IP to
          use the Services on a compatible device in your control or ownership.
          Any other use, in particular any copy, display, download, post,
          reproduce, republish, scrape, transfer, or transmission, in any form
          or by any means, in whole or in part, to third parties or distribution
          or making available of the IP is not permitted and requires the prior
          written consent of Mimo. Furthermore, &ldquo;Mimo&rdquo; and all other
          trademarks, service marks, graphics and logos used in connection with
          the Services are owned by Mimo or our licensors. Access or use of the
          Services does not grant or provide you with the right or license to
          use these trademarks, service marks, graphics, and logos.
        </p>
        <h3 className="text-xl font-semibold">3.2</h3>
        <p>
          You may not derive or attempt to derive the source code of any part of
          the Services, permit any third party to derive or attempt to derive
          such source code, or decompile, disassemble, reverse engineer, or
          translate the Services or any part thereof.
        </p>

        <h2 className="text-3xl font-bold">4. Content</h2>
        <h3 className="text-xl font-semibold">4.1</h3>
        <p>
          By creating, storing, or submitting any images, information, reviews,
          source code, text, translations or other materials through the
          Services (&ldquo;Content&rdquo;), you grant Mimo an irrevocable,
          non-exclusive, unlimited in time, perpetual, royalty-free,
          transferable, and worldwide license to use, edit, reproduce, copy,
          create derivative works from, display, make available or publish,
          distribute, excerpt, reformat, reuse and translate such Content for
          providing the Services as well as personalizing your experience of and
          promoting the Services.
        </p>
        <h3 className="text-xl font-semibold">4.2</h3>
        <p>Furthermore, you</p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>
            represent that you own or have the necessary legal rights for the
            Content to be used by you through the Services;
          </li>
          <li>
            warrant that you will not create, store, submit, or otherwise
            provide through the Services any Content that is
            <ul className="list-disc pl-5">
              <li>
                abusive, harassing, hateful, offensive, threatening, or
                otherwise violates any law or infringes the rights of any third
                party (including copyright, privacy, publicity, trademark, or
                other personal or proprietary rights);
              </li>
              <li>
                explicit or objectionable, damages, exploits, or otherwise
                impairs the Services in any way (in particular, but not
                exclusively, scams, conspiracy theories, content that violates
                the protection of minors); or
              </li>
              <li>
                exposing Mimo or any third party to harm or liabilities of any
                kind.
              </li>
            </ul>
          </li>
        </ol>
        <h3 className="text-xl font-semibold">4.3</h3>
        <p>Furthermore, Mimo reserves the right to</p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>monitor content created and stored through the Services;</li>
          <li>remove any Content that is considered inappropriate; and</li>
          <li>
            terminate your access to the Services at any time, particularly for
            violations of these ToS.
          </li>
        </ol>

        <h2 className="text-3xl font-bold">5. Promotional Codes</h2>
        <h3 className="text-xl font-semibold">5.1</h3>
        <p>
          Mimo may occasionally offer you promotional codes to purchase
          Subscriptions for various Subscription Periods at a discount
          (&ldquo;Promotional Code&rdquo;).
        </p>
        <h3 className="text-xl font-semibold">5.2</h3>
        <p>
          At its sole discretion, Mimo may determine your eligibility for a
          Promotional Code and suspend or discontinue Promotional Codes at any
          time.
        </p>
        <h3 className="text-xl font-semibold">5.3</h3>
        <p>
          Promotional Codes cannot be redeemed for cash, refunded, exchanged or
          used for purchases other than those stipulated in the offer.
        </p>
        <h3 className="text-xl font-semibold">5.4</h3>
        <p>
          Specific provisions relating to the Promotional Code may apply in
          addition to the ToS. If these provisions stipulate a period of
          validity, the discount only applies for such period.
        </p>

        <h2 className="text-3xl font-bold">6. Revocation</h2>
        <h3 className="text-xl font-semibold">6.1</h3>
        <p>
          By default, we exclude the revocation of this contract
          (&ldquo;Revocation&rdquo;) by complying with the legal conditions of §
          18 FAGG in the purchase process so that you can use our Services
          immediately.
        </p>
        <h3 className="text-xl font-semibold">6.2</h3>
        <p>
          However, if you have purchased a Subscription or other Services
          subject to charges as a consumer and we did not comply with § 18 FAGG,
          you may state Revocation. Therefore, we inform you that
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>
            the right will exist for a period of fourteen days from the day of
            the purchase (&ldquo;Revocation Period&rdquo;);
          </li>
          <li>
            to exercise the Revocation, you are required to notify Mimo via mail
            or email.
          </li>
          <li>
            dispatch of the Revocation Notification before the Revocation Period
            expires is sufficient to execute the Revocation.
          </li>
        </ol>
        <h3 className="text-xl font-semibold">6.3</h3>
        <p>
          If a Revocation is permissible and you wish to revoke please complete
          and return the following form to Mimo GmbH, Währinger Str. 2-4/48,
          1090 Vienna, Austria or support@mimo.org:
        </p>
        <pre className="mt-4 whitespace-pre-wrap">
          I hereby revoke the contract concluded by me regarding the performance
          of the following service:
          <br />
          Ordered on:
          <br />
          Name:
          <br />
          Address: <br />
          Signature (if provided on paper):
          <br />
          Date:
        </pre>
        <h3 className="text-xl font-semibold">6.4</h3>
        <p>
          If you properly revoke this contract, Mimo will refund your purchase
          by no later than fourteen days from the day of receipt of the
          Revocation Notification using the same payment method for the refund
          that you have used for the original transaction, unless a deviating
          method has been stipulated with you.
        </p>

        <h2 className="text-3xl font-bold">7. Termination</h2>
        <h3 className="text-xl font-semibold">7.1</h3>
        <p>
          Any Subscription shall exist for the Subscription Period or any other
          period agreed. You can terminate a Subscription you have purchased
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>on the Websites, in your account settings on the Websites;</li>
          <li>within our Apps, through the App Stores.</li>
        </ol>
        <h3 className="text-xl font-semibold">7.2</h3>
        <p>
          Termination of a Subscription will become effective upon lapse of the
          last day of the Subscription Period or any other period agreed.
        </p>
        <h3 className="text-xl font-semibold">7.3</h3>
        <p>
          You may terminate any other Services by deleting your account in the
          account settings within the Apps or on the Websites. However, if you
          entered into a Subscription, deleting your account does not
          automatically terminate your Subscription.
        </p>
        <h3 className="text-xl font-semibold">7.4</h3>
        <p>
          Upon re-entering into a Subscription, you regain the ability to use
          the extended scope of the Services.
        </p>
        <h3 className="text-xl font-semibold">7.5</h3>
        <p>
          Notwithstanding the foregoing, any Contract may be terminated at any
          time for good cause by either party without notice.
        </p>

        <h2 className="text-3xl font-bold">
          8. Limitation on Types of Damages and Liability
        </h2>
        <h3 className="text-xl font-semibold">8.1</h3>
        <p>
          Mimo excludes any claims for damages against it related to our
          contractual relationship, except based on intentional or grossly
          negligent behavior by Mimo and in relation to personal injury. This
          restriction of liability also applies to Mimo affiliates and legal
          representatives of Mimo and Mimo affiliates in case claims are made
          directly against them.
        </p>

        <h2 className="text-3xl font-bold">9. Miscellaneous</h2>
        <h3 className="text-xl font-semibold">9.1</h3>
        <p>
          If any provision of the ToS is invalid, the remainder of it remains
          valid and statutory regulations take effect over the invalid
          provisions.
        </p>
        <h3 className="text-xl font-semibold">9.2</h3>
        <p>
          Amendments, supplements, and ancillary agreements of the ToS must be
          made in writing to be effective. This also applies to the agreement to
          derivate from this formal requirement.
        </p>
        <h3 className="text-xl font-semibold">9.3</h3>
        <p>
          In case of contradictions between the ToS and deviating written
          agreements between you and Mimo, the provisions of the deviating
          agreements shall prevail.
        </p>
        <h3 className="text-xl font-semibold">9.4</h3>
        <p>
          The laws of the Republic of Austria apply, excluding the United
          Nations Convention on the International Sale of Goods
          (&ldquo;CISG&rdquo;) and the conflict-of-law rules of private
          international law. With respect to customers, this choice of law shall
          only apply to the extent that the protection granted by the mandatory
          provisions of the law of the state of the consumer&apos;s habitual
          residence is not thereby withdrawn.
        </p>
        <h3 className="text-xl font-semibold">9.5</h3>
        <p>
          The exclusive place of jurisdiction for disputes, directly or
          indirectly resulting from the contractual relationship, is the
          respective court at Mimo’s registered seat of business. With respect
          to customers, this place of jurisdiction shall only apply to the
          extent that national law does not provide a mandatory place of
          jurisdiction for consumers.
        </p>

        <p className="!mt-10 text-sm">
          These terms were last modified on September 25, 2024, and took effect
          on October 3, 2024.
        </p>
      </div>
    </div>
  );
}
